import styled from "@emotion/styled";

import { ContentItemHomeHeroArticle } from "~/components/content/content-item-render/variants/home-hero-article";

export const StyledContentItemHomeHeroArticle = styled(ContentItemHomeHeroArticle)``;
